<div class="adaptive-grow-1">
  <div class="fluent-container">
    <br />
    <div class="title-color">
      @if (!employeeSelected) {
        <h1 class="title">Crear dinamizador</h1>
      }
    </div>
    <div class="title-color">
      @if (employeeSelected) {
        <h1 class="title">Editar dinamizador</h1>
      }
    </div>
    <div class="form-body">
      <form [formGroup]="employeeForm" (ngSubmit)="saveEmployee()">
        <div class="line">
          <div class="form-grid cols-2">
            <mat-form-field appearance="outline">
              <mat-label>Nombre</mat-label>
              <input
                type="text"
                matInput
                placeholder="Nombre"
                formControlName="name"
                maxlength="256"
                required
                oninput="this.value = this.value.toUpperCase()"
              />
              @if (employeeForm.get('name')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
              @if (employeeForm.get('name')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 256 caracteres
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Tipo de relación</mat-label>
              <input
                type="text"
                matInput
                placeholder="Tipo de relación"
                formControlName="relationshipType"
                maxlength="256"
                required
                oninput="this.value = this.value.toUpperCase()"
              />
              @if (employeeForm.get('relationshipType')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 256 caracteres
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Descripción</mat-label>
              <textarea
                matInput
                placeholder="Descripción"
                formControlName="description"
                required
                oninput="this.value = this.value.toUpperCase()"
              ></textarea>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Experiencia comunitaria</mat-label>
              <textarea
                matInput
                placeholder="Experiencia comunitaria"
                formControlName="communityExperience"
                required
                oninput="this.value = this.value.toUpperCase()"
              ></textarea>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Experiencia académica</mat-label>
              <textarea
                matInput
                placeholder="Experiencia académica"
                formControlName="academicExperience"
                required
                oninput="this.value = this.value.toUpperCase()"
              ></textarea>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Funciones</mat-label>
              <input
                type="text"
                matInput
                placeholder="Funciones"
                formControlName="functions"
                maxlength="256"
                required
                oninput="this.value = this.value.toUpperCase()"
              />
              @if (employeeForm.get('functions')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 256 caracteres
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Tiempo de experiencia</mat-label>
              <input
                type="number"
                matInput
                placeholder="Tiempo de experiencia"
                formControlName="experienceTime"
                required
              />
            </mat-form-field>

            <div class="checkbox-grid">
              <mat-checkbox
                matInput
                formControlName="hasMultipleComponents"
                title="hasMultipleComponents"
                >Componentes múltiples</mat-checkbox
              >
              <mat-checkbox matInput formControlName="hasMultipleLevels" title="hasMultipleLevels"
                >Niveles múltiples</mat-checkbox
              >
            </div>

            <mat-form-field appearance="outline">
              <mat-label>Tiempo de acompañamiento</mat-label>
              <input
                type="text"
                matInput
                placeholder="Tiempo de acompañamiento"
                formControlName="accompanimenTime"
                maxlength="256"
                required
                oninput="this.value = this.value.toUpperCase()"
              />
              @if (employeeForm.get('accompanimenTime')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 256 caracteres
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Tipo de compensación</mat-label>
              <input
                type="text"
                matInput
                placeholder="Tipo de compensación"
                formControlName="compensacionType"
                maxlength="256"
                required
                oninput="this.value = this.value.toUpperCase()"
              />
              @if (employeeForm.get('compensacionType')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 256 caracteres
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Salario mensual</mat-label>
              <input
                type="number"
                matInput
                placeholder="Salario mensual"
                formControlName="monthSalary"
                required
              />
            </mat-form-field>

            <div class="search-select-container">
              <app-search-select
                [dataList]="expenseSelected"
                [initialValue]="getExpenseValue()"
                placeholder="Gasto"
                label="Gasto"
                noResults="Sin resultados"
                (onSelectOption)="onExpenseSelected($event)"
              >
              </app-search-select>
            </div>
          </div>
        </div>
        <button type="submit" class="primary-button" [disabled]="!employeeForm.touched">
          <span class="button-content"> <mat-icon fontIcon="save"></mat-icon>Guardar </span>
        </button>

        <button type="button" (click)="closeDialog()" class="secondary-button" id="cancelar">
          <span class="button-content"><mat-icon>close</mat-icon>Cancelar</span>
        </button>
      </form>
    </div>
  </div>
</div>
